import { providersReady } from "./providers";
import { getActiveProvider } from "./registry";
import type { AnalyticsAnonymousContext, AnalyticsIdentifyContext } from "./types";
import logger from "@utils/logger";

export async function identifyUser(context: AnalyticsIdentifyContext): Promise<void> {
  logger._console.log("[analytics] identifyUser", { memberId: context.member?.id });
  await providersReady;
  await getActiveProvider()?.identify(context);
}

export async function resetAnalyticsUser(): Promise<void> {
  logger._console.log("[analytics] resetAnalyticsUser");
  await providersReady;
  await getActiveProvider()?.reset();
}

export async function setAnonymousAnalyticsContext(context: AnalyticsAnonymousContext): Promise<void> {
  await providersReady;
  await getActiveProvider()?.setAnonymousContext(context);
}
